import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PayDriver,
    PayShop,
    PaySupplier,
    PaymentRecieved,
    PaymentFastag,
    TransactionHistory,
    TransactionPending
 } from '../TopCard/icons';
 import { numberFormat,getDateInStringDDMMMYYYY,getVehicleNumberValuesDWeb,numberFormatPaisaV1 } from '../../../utils/utils';
 import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
 import UPI from './upi.png';
 import TransportPayWallet from './TransportPayWallet.svg';
 import CreditCard from './credit-card.png';
 import DebitCard from './debit-card.png';
 import NetBanking from './NetBanking.svg';
 import Reward from './rewards.png';
 import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent
} from '@material-ui/lab';
import BankIcon from '../../../assets/bank-icon-white.svg';
import BankIconOrange from '../../../assets/bank-icon-orange.svg';
import ErrorIconRed from '../../../assets/transaction-error-icon-red.svg';
import ErrorIconWhite from '../../../assets/transaction-error-icon-white.svg';
import PendingIconWhite from '../../../assets/transaction-pending-icon-white.svg';
import PendingIconOrange from '../../../assets/transaction-pending-icon-orange.svg';
import RefundSuccessWhite from '../../../assets/refund-successful-white-icon.svg';
import RefundPendingOrange from '../../../assets/refund-pending-orange-icon.svg';
import RefundSuccessGreen from '../../../assets/refund-successful-green.svg';
import RefundFailedIcon from '../../../assets/refund-failed-red.svg';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import VehicleNumberFormat from '../../pages/Expenses/VehicleNumberFormat';
import WarningIcon from '@material-ui/icons/Warning';
const useStyles = makeStyles((theme) => ({
  paymentCard: {
      boxShadow:'none',
      borderRadius:8,
  },
  paymentToCard: {
      boxShadow:'none',
      borderRadius:8,
      marginTop:16
  },
  paymentModeUsedCard: {
      boxShadow:'none',
      borderRadius:8,
      marginTop:16
  },
  detailsDiv:{
      padding:16
  },
  detailsDiv1:{
      marginTop:24
  },
  successDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#e1fce6",
      borderTopLeftRadius:8,
      borderTopRightRadius:8,
      color:'#0b1323'
  },
  pendingDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#fee6b9",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  failureDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#f8cece",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  successIcon:{
      marginRight:16,
      color:"#24ad31"
  },
  pendingIcon:{
      marginRight:16,
      color:"#fc6f08"
  },
  failureIcon:{
      marginRight:16,
      color:"#e61b1b"
  },
  headerTxt:{
      fontSize:16,
      fontWeight:600,
      color:"#0b1323"
  },
  section:{
      marginBottom:16,
      display:'flex',
      flexDirection:'column',
      "&:last-child": {
        marginBottom: 0
      }
  },
  subTitleSec:{
      marginBottom:2,
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  valueSec:{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  subTitleTxt:{
      fontSize:12,
      fontWeight:500,
      color: "rgba(11, 19, 35, 0.5)"
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  },
  cardHeader:{
    fontSize:16,
    fontWeight:600,
    color:'#0b1323',
    marginBottom:16
  },
  amount:{
    fontWeight:600,
    color:'#000',
    fontSize:14,
    textAlign:'right'
  },
  modeValueTxt:{
    fontSize:14,
    marginLeft:16
  },
  timeLineItemRoot: {
      minHeight: 'fit-content'
  },
  timeLineItemRootWithoutConnecter: {
      minHeight: 'fit-content',
      alignItems:'center'
  },
  missingOppositeContentV1: {
      '&:before': {
          flex: 'inherit',
          content: 'none',
          padding: '0px !important'
      }
  },
  timeLineV1: {
      padding: '0px !important',
      margin: '0px !important'
  },
  timelineCard:{
    marginTop:16,
    padding:24,
    borderRadius:8,
    backgroundColor:'#fff',
    boxShadow:'none',
    overflow:'initial'
  },
  rootDotSuccessful: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 18,
      backgroundColor: '#24ad31',
      boxShadow: 'none !important'
  },
  lineConnectorRoot: {
      minHeight: 58,
      backgroundColor: '#24ad31'
  },
  lineConnectorPending: {
      minHeight: 48,
      width:3,
      backgroundColor: '#e4e4e4'
  },
  contentRootV1: {
      paddingLeft: 12,
      paddingRight: 12,
      paddingBottom: '0px !important',
      paddingTop: '0px !important',
      marginTop: '-4px',
      height: 'fit-content'
  },
  titleV5: {
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'left',
      color: '#0b1323'
  },
  textV5: {
      fontSize: 12,
      fontWeight: 'normal',
      textAlign: 'left',
      color: '#0b1323'
  },
  modeNote:{
    color:'#fc6f08',
    textAlign:'right',
    fontSize:12
  },
  rootDotPending: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 22,
      backgroundColor: '#FC6F08',
      boxShadow: 'none !important'
  },
  rootDotSuccessful: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 18,
      backgroundColor: '#24ad31',
      boxShadow: 'none !important'
  },
  rootDotFailed: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 22,
      backgroundColor: '#e61b1b',
      boxShadow: 'none !important'
  },
  rootDotFailedV1: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 22,
      backgroundColor: '#f8cece',
      boxShadow: 'none !important'
  },
  rootDotSuccessfulV1: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 22,
      backgroundColor: '#24ad31',
      boxShadow: 'none !important'
  },
  rootDotPendingV1: {
      width: '32px',
      height: '32px',
      padding: '0px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0px !important',
      fontSize: 22,
      backgroundColor: '#fee6b9',
      boxShadow: 'none !important'
  },
  timelineFailureIcon:{
      fontSize:14
  },
  warningCard:{
      marginTop:8,
      padding:'16px 18px',
      borderRadius:8,
      backgroundColor:'#fff',
      fontSize:14
  }
}));
const PaymentDetailsCard = (props) => {
  const { 
      title,
      type,
      data
    } = props;
  const classes = useStyles();
  let TRANSFER_SUCCESSFULL = ['SUCCESS'];
  let REFUND_INITIATED_PAYMENT_STATUS = [];
  let REFUNDED_PAYMENT_STATUS = [];
  const PAYMENT_SUCCESSFULL = ['SUCCESS','RELEASED'];
  const PAYMENT_PENDING = ['PENDING','PENDING_AT_BROKER'];
  const PENDING_AT_BROKER = ['PENDING_AT_BROKER'];
  const FAILED_AT_BANK = ['FAILED_AT_BROKER'];
  const TRANSFER_FAILED = ['USER_DROPPED','FAILED'];
  const TRANSFER_PENDING = ['PENDING'];
  const REFUND_SUCEESSFULL = ['SUCCESS'];
  const REFUND_INITIATED_STATUS = ['PENDING','REFUND_INITIATED'];
  const REFUND_FAILED_STATUS = ['REFUND_FAILED','FAILED']
  const getPaymentStatus = (type)=>{
    switch (type) {
        case "SUCCESS":
            return <div className={classes.successDiv}>
                        <CheckCircleOutlineOutlinedIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Recharge Successful':''}</Typography>
                   </div>
        case "RELEASED":
            return <div className={classes.successDiv}>
                        <CheckCircleOutlineOutlinedIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Recharge Successful':'Payment Successful'}</Typography>
                   </div>
        case "FAILED":
            return <div className={classes.failureDiv}>
                        <ErrorOutlineOutlinedIcon className={classes.failureIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Transfer Failed':'Transfer Failed'}</Typography>
                   </div>
        case "USER_DROPPED":
            return <div className={classes.failureDiv}>
                        <ErrorOutlineOutlinedIcon className={classes.failureIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Transfer Failed':'Transfer Failed'}</Typography>
            </div>
        case "REFUNDED":
            return <div className={classes.successDiv}>
                        <CheckCircleOutlineOutlinedIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Refund Successful':'Refund Successful'}</Typography>
                   </div>
        case "PARTIAL_REFUND":
            return <div className={classes.successDiv}>
                        <CheckCircleOutlineOutlinedIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Refund Successful':'Refund Successful'}</Typography>
                   </div>
        case "PENDING":
            return <div className={classes.pendingDiv}>
                    <img src={PendingIconOrange} width={32} height={32} style={{marginRight:16}}/>
                    <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Transfer Pending':'Transfer Pending'}</Typography>
                  </div>
        case "PROCESSING":
            return <div className={classes.pendingDiv}>
                    <img src={PendingIconOrange} width={32} height={32} style={{marginRight:16}}/>
                    <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Transfer Pending':'Transfer Pending'}</Typography>
                  </div>
        case "PENDING_AT_BROKER":
            return <div className={classes.pendingDiv}>
                    {/* <TransactionPending className={classes.pendingIcon} /> */}
                    <img src={BankIconOrange} width={32} height={32} style={{marginRight:16}}/>
                    <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Transfer Pending':'Transfer Pending'}</Typography>
                  </div>
        case "REFUND_FAILED":
            return <div className={classes.pendingDiv}>
                    <img src={RefundPendingOrange} width={32} height={32} style={{marginRight:16}}/>
                    <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Refund Failed':'Refund Failed'}</Typography>
                  </div>
        case "REFUND_INITIATED":
            return <div className={classes.pendingDiv}>
                    <img src={RefundPendingOrange} width={32} height={32} style={{marginRight:16}}/>
                    <Typography className={classes.headerTxt}>{data.paymentTitle?data.paymentTitle:data.brokerId?'Refund Initiated':'Refund Initiated'}</Typography>
                  </div>
        default:
            return ""
    }
  }
  const getPaymentMode = (type)=>{
    switch (type) {
        case "CREDIT_CARD":
            return <img src={CreditCard} width={24} height={24} />
        case "DEBIT_CARD":
            return <img src={DebitCard} width={24} height={24} />
        case "UPI":
                return <img src={UPI} width={24} height={24} />
        case "PhonePe":
            return <img src={UPI} width={24} height={24} />
        case "WALLET":
            return <img src={TransportPayWallet} width={24} height={24} />
        case "NET_BANKING":
            return <img src={NetBanking} width={24} height={24} />
        case "REWARDS":
            return <img src={Reward} width={24} height={24} />
        default:
            return ""
    }
  }
  const getSubTitle = (type)=>{
    switch (type) {
        case "vendor":
            return "Supplier Name";
        case "shop":
            return "Shop Name";
        case "driver":
            return "Driver Name";
        case "customer":
            return "Party Name";
        case "fastag":
            return "Vehicle Number";
        case "fuelcard":
            return "Vehicle Number";    
        default:
            return null
      }
  }
  const getSubPaymentType= (amount)=>{
    switch (amount) {
        case amount<0:
            return "Credit";
        case  amount>0:
            return "Payment";
        default:
            return null
      }
  }
  const getTypeName = ()=>{
    if(data && data.vendorId)
        return "Supplier";
    if(data && data.shopId)
        return "Shop";
    if(data && data.driverId)
        return "Driver";
    if(data && data.vehicleId)
        return "Vehicle";
    if(data && data.customerId)
        return "Party";
    if(data && data.brokerId)
        return "Vehicle";
    return 'User'
  }
  const getDetailsCard = ()=>{
    if(data && (data.shopId || data.driverId || data.vendorId || data.brokerId || data.customerId)){
        return <>
            <div className={classes.section}>
                {<div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>{getTypeName()}&nbsp;{data.brokerId?'No':'Name'}</Typography>
                    <Typography className={classes.subTitleTxt}>Payment Amount</Typography>
                </div>}
                <div className={classes.valueSec}>
                    {!data.brokerId && <Typography className={classes.valueTxt}>{data && data.name?data.name:"---"}</Typography>}
                    {data.brokerId && <Typography className={classes.valueTxt}><VehicleNumberFormat value={data && data.vehicleNumber?data.vehicleNumber:null} size={16} /></Typography>}
                    <Typography className={classes.valueTxt}>{data && data.amount?numberFormatPaisaV1(data.amount):""}</Typography>
                </div>
            </div>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Payment Date</Typography>
                </div>
                <div className={classes.valueSec}>
                    {!data.brokerId &&<Typography className={classes.valueTxt}>{data && data.date?getDateInStringDDMMMYYYY(data.date):""}</Typography>}
                    {data.brokerId &&<Typography className={classes.valueTxt}>{data && data.transactionDate?data.transactionDate:''}&nbsp;{data && data.transactionTime?data.transactionTime:''}</Typography>}
                </div>
            </div>
            {(data.shopId || data.driverId) && <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Reason for Sending Money</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt}>{data && data.description?data.description:"-/-"}</Typography>
                </div>
            </div>}
        </>
    }else{
        return <>
            <div className={classes.section}>
                {<div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>{getTypeName()}&nbsp;{data.brokerId?'No':'Name'}</Typography>
                    <Typography className={classes.subTitleTxt}>Payment Amount</Typography>
                </div>}
                <div className={classes.valueSec}>
                    {!data.brokerId && <Typography className={classes.valueTxt}>{data && data.name?data.name:"---"}</Typography>}
                    {data.brokerId && <Typography className={classes.valueTxt}><VehicleNumberFormat value={data && data.vehicleNumber?data.vehicleNumber:null} size={16} /></Typography>}
                    <Typography className={classes.valueTxt}>{data && data.amount?numberFormat(data.amount):""}</Typography>
                </div>
            </div>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Payment Date</Typography>
                    {data && data.description &&<Typography className={classes.subTitleTxt}>Description</Typography>}
                </div>
                <div className={classes.valueSec}>
                    {!data.brokerId &&<Typography className={classes.valueTxt}>{data && data.date?getDateInStringDDMMMYYYY(data.date):""}</Typography>}
                    {data.brokerId &&<Typography className={classes.valueTxt}>{data && data.transactionDate?data.transactionDate:''}&nbsp;{data && data.transactionTime?data.transactionTime:''}</Typography>}
                    {data && data.description && <Typography className={classes.valueTxt}>{data && data.description?data.description:"---"}</Typography>}
                </div>
            </div>
        </>
    }
  }

  const getBanKDetailsCard = ()=>{
    if(data && data.accType && data.accType == 'BANK'){
        return <>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Account Holder Name</Typography>
                    <Typography className={classes.subTitleTxt}>Account Number</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt}>{data && data.accHolderName?data.accHolderName:"---"}</Typography>
                    <Typography className={classes.valueTxt}>{data && data.accNumber?data.accNumber:"---"}</Typography>
                </div>
            </div>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>{getTypeName()} Bank</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt}>{data && data.bankName?data.bankName:"---"}</Typography>
                </div>
            </div>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Transcation ID</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt} style={{width:'100%',overflowWrap:'break-word'}}>{data && data.paymentRefId?data.paymentRefId:data.paymentUTR?data.paymentUTR:"---"}</Typography>
                </div>
            </div>
        </>
    }else if(data && data.accType && data.accType == 'UPI'){
        return <>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>{getTypeName()} UPI Id</Typography>
                    <Typography className={classes.subTitleTxt}>Transcation ID</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt}>{data && data.upiAddress?data.upiAddress:"---"}</Typography>
                    <Typography className={classes.valueTxt} style={{width:'40%',overflowWrap:'break-word',textAlign:'right'}}>{data && data.paymentRefId?data.paymentRefId:data && data.paymentUTR?data.paymentUTR:"---"}</Typography>
                </div>
            </div>
        </>
    }else if(data && data.brokerId){
        return <>
            <div className={classes.section}>
                <div className={classes.subTitleSec} >
                    <Typography className={classes.subTitleTxt}>Diesel Card</Typography>
                    <Typography className={classes.subTitleTxt}>Order ID</Typography>
                </div>
                <div className={classes.valueSec}>
                    <Typography className={classes.valueTxt}>{data && data.brokerName?data.brokerName:"---"}</Typography>
                    <Typography className={classes.valueTxt}>{data && data.orderId?data.orderId:"---"}</Typography>
                </div>
            </div>
        </>
    }
  }
  const getTimelineCard = ()=>{
    if(data){
        let paymentStatus = data.paymentStatus?data.paymentStatus:null;
        let payOutStatus = data.payoutStatus?data.payoutStatus:null;
        let refundStatus = data.refundStatus?data.refundStatus:null;
        let transactionStatus = data.transaction_status?data.transaction_status:null;
        let entity = data.entityTransactionDetails?data.entityTransactionDetails:null;
        let entityPaymentStatus = entity&&entity.paymentStatus?entity.paymentStatus:paymentStatus;
        let entityPayOutStatus = entity&&entity.payoutStatus?entity.payoutStatus:payOutStatus;
        let entityRefundStatus = entity&&entity.refundStatus?entity.refundStatus:refundStatus
        if(!entityPaymentStatus && !entityPayOutStatus && !entityRefundStatus){
            return <></>
        }
        if(entityPaymentStatus && entityPaymentStatus=='REFUND_INITIATED'&&!entityPayOutStatus && !entityRefundStatus){
            REFUND_INITIATED_PAYMENT_STATUS.push('REFUND_INITIATED')
        }else{
            TRANSFER_SUCCESSFULL.push('REFUND_INITIATED');
        }
        if(entityPaymentStatus && entityPaymentStatus=='REFUNDED' && !entityPayOutStatus && !entityRefundStatus){
            REFUNDED_PAYMENT_STATUS.push('REFUNDED');
        }else{
            TRANSFER_SUCCESSFULL.push('REFUNDED');
        }
        return <><Card className={classes.timelineCard}>
            <Timeline className={classes.timeLineV1}>
                {TRANSFER_SUCCESSFULL.includes(entityPaymentStatus)&&<TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                    <TimelineSeparator>
                        <TimelineDot classes={{ root: classes.rootDotSuccessful }}>
                            &#8377;
                        </TimelineDot>
                        <TimelineConnector classes={{ root: !PAYMENT_SUCCESSFULL.includes(entityPayOutStatus) ? classes.lineConnectorPending : classes.lineConnectorRoot }} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                        <div className={classes.titleV5}>Transfer Successful</div>
                        <div className={classes.textV5}>{entity && entity.paymentTime ? entity.paymentTime:entity && entity.paymentUpdatedAt?entity.paymentUpdatedAt: data && data.brokerId?`${data.transactionDate} ${data.transactionTime}`:''}</div>
                    </TimelineContent>
                </TimelineItem>}
                {PAYMENT_SUCCESSFULL.includes(entityPayOutStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotSuccessfulV1 }}>
                                <img src={BankIcon} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Payment Successful</div>
                            <div className={classes.textV5}>{entity && entity.payoutUpdatedAt ? entity.payoutUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {TRANSFER_SUCCESSFULL.includes(entityPaymentStatus) && FAILED_AT_BANK.includes(entityPayOutStatus)&&
                    <TimelineItem classes={{ root: entityRefundStatus?classes.timeLineItemRoot:classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotFailed }}>
                                <ErrorOutlineOutlinedIcon className={classes.timelineFailureIcon} />
                            </TimelineDot>
                            <TimelineConnector classes={{ root: classes.lineConnectorPending}} />
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Payment Failed at Bank</div>
                            <div className={classes.textV5}>{entity && entity.payoutUpdatedAt ? entity.payoutUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {TRANSFER_SUCCESSFULL.includes(entityPaymentStatus) && PAYMENT_PENDING.includes(entityPayOutStatus)&&
                    <TimelineItem classes={{ root: entityRefundStatus?classes.timeLineItemRoot:classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={BankIconOrange} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Payment Pending</div>
                            <div className={classes.textV5}>{entity && entity.payoutUpdatedAt ? entity.payoutUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {TRANSFER_SUCCESSFULL.includes(entityPaymentStatus) && FAILED_AT_BANK.includes(entityPayOutStatus)&&!entityRefundStatus&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={RefundPendingOrange} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Initiated</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {/* {PENDING_AT_BROKER.includes(entityPayOutStatus)&&
                    <TimelineItem classes={{ root: entityRefundStatus?classes.timeLineItemRoot:classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={BankIconOrange} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Waiting for your Bank to Confirm</div>
                            <div className={classes.textV5}>We are trying to complete the recharge with your fastag bank and we will notify you, once the recharge is sucessful.</div>
                        </TimelineContent>
                    </TimelineItem>
                } */}
                {REFUND_SUCEESSFULL.includes(entityRefundStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotSuccessfulV1 }}>
                                <img src={RefundSuccessWhite} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Successful</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {REFUNDED_PAYMENT_STATUS && REFUNDED_PAYMENT_STATUS.length>0&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotSuccessfulV1 }}>
                                <img src={RefundSuccessWhite} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Successful</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {REFUND_INITIATED_STATUS.includes(entityRefundStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={RefundPendingOrange} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Initiated</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {REFUND_INITIATED_PAYMENT_STATUS && REFUND_INITIATED_PAYMENT_STATUS.length>0&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={RefundPendingOrange} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Initiated</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {paymentStatus =='REFUND_FAILED' && !entityPayOutStatus&&!entityRefundStatus&&
                    <TimelineItem classes={{ root:classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotFailed }}>
                                <ErrorOutlineOutlinedIcon className={classes.timelineFailureIcon} />
                            </TimelineDot>
                            <TimelineConnector classes={{ root: classes.lineConnectorPending}} />
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Payment Failed</div>
                            <div className={classes.textV5}>&nbsp;</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {paymentStatus =='REFUND_FAILED' && !entityPayOutStatus&&!entityRefundStatus&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                <img src={RefundPendingOrange} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Initiated</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {REFUND_FAILED_STATUS.includes(entityRefundStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotFailed }}>
                                <img src={RefundFailedIcon} width={14} height={14} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Refund Failed</div>
                            <div className={classes.textV5}>{entity && entity.paymentUpdatedAt ? entity.paymentUpdatedAt : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {TRANSFER_FAILED.includes(entityPaymentStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotFailed }}>
                                <ErrorOutlineOutlinedIcon className={classes.timelineFailureIcon} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Transfer Failed</div>
                            <div className={classes.textV5}>{entity && entity.paymentTime ? entity.paymentTime : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
                {TRANSFER_PENDING.includes(entityPaymentStatus)&&
                    <TimelineItem classes={{ root: classes.timeLineItemRootWithoutConnecter, missingOppositeContent: classes.missingOppositeContentV1 }}>
                        <TimelineSeparator>
                            <TimelineDot classes={{ root: classes.rootDotPending }}>
                                <img src={PendingIconWhite} width={14} height={14} className={classes.imgV1} />
                            </TimelineDot>
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: classes.contentRootV1 }}>
                            <div className={classes.titleV5}>Transfer Pending</div>
                            <div className={classes.textV5}>{entity && entity.paymentTime ? entity.paymentTime : ""}</div>
                        </TimelineContent>
                    </TimelineItem>
                }
            </Timeline>
        </Card>
        {TRANSFER_FAILED.includes(entityPaymentStatus)&&<Box className={classes.warningCard} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <span>Any money deducted will be refunded in <strong>7-10 business days</strong></span>
        </Box>}
        {TRANSFER_PENDING.includes(entityPaymentStatus)&&<Box className={classes.warningCard} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <WarningIcon htmlColor={'#e61b1b'} />
            <span style={{marginLeft:20}}>We will automatically cancel the payment if it is pending for more than <strong>10 mins</strong>. Any amount deducted will be refunded to you</span>
        </Box>}
        </>
    }
  }
  return (
    <>
      <Paper className={classes.paymentCard}>
            <div>
                {getPaymentStatus(data && (data.paymentStatus=='SUCCESS' && data.payoutStatus=='PENDING_AT_BROKER')?data.payoutStatus:data.paymentStatus?data.paymentStatus:null)}
            </div>
            <div className={classes.detailsDiv}>
                {getDetailsCard()}
            </div>
      </Paper>
      {data && (data.brokerId || (data.accType && (data.accType == 'BANK' || data.accType == 'UPI'))) && <Paper className={classes.paymentToCard}>
            <div className={classes.detailsDiv}>
                <Typography className={classes.cardHeader}>Paid To</Typography>
                {getBanKDetailsCard()}
            </div>
      </Paper>}
      {data && data.paymentModesUsed && data.paymentModesUsed.length>0 && <Paper className={classes.paymentModeUsedCard}>
            <div className={classes.detailsDiv}>
                <Typography className={classes.cardHeader}>Paid Using</Typography>
                {data.paymentModesUsed.map((mode)=>{
                    return <div className={classes.section}>
                    <div className={classes.valueSec}>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            {getPaymentMode(mode && mode.paymentMode? mode.paymentMode.toUpperCase():'')}
                            <Typography className={classes.modeValueTxt}>{mode && mode.paymentAppName?mode.paymentAppName:"---"}</Typography>
                        </Box>
                        <Box component={'div'} display={'flex'} flexDirection={'column'} justifyContent={'end'}>
                            <Typography className={classes.amount}>{mode && mode.transactionAmount?numberFormatPaisaV1(mode.transactionAmount):"---"}</Typography>
                            {mode.txnChargeDetails && <span className={classes.modeNote}>{mode.txnChargeDetails}</span>}
                        </Box>
                    </div>
                </div>
                })}
            </div>
      </Paper>}
      {data && data.paymentModesUsed && data.paymentModesUsed.length <=0 && data.paymentMode && data.paymentMode=='NET_BANKING' && <Paper className={classes.paymentModeUsedCard}>
            <div className={classes.detailsDiv}>
                <Typography className={classes.cardHeader}>Paid Using</Typography>
                <div className={classes.section}>
                    <div className={classes.valueSec}>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            {getPaymentMode(data && data.paymentMode? data.paymentMode.toUpperCase():'')}
                            <Typography className={classes.modeValueTxt}>Net Banking</Typography>
                        </Box>
                        <Box component={'div'} display={'flex'} flexDirection={'column'} justifyContent={'end'}>
                            <Typography className={classes.amount}>{data && data.payout_amount?numberFormatPaisaV1(data.payout_amount):"---"}</Typography>
                        </Box>
                    </div>
                </div>
            </div>
      </Paper>}
      {data && (!data.paymentModesUsed || data.paymentModesUsed && data.paymentModesUsed.length <=0) && data.brokerId && data.paymentMode && <Paper className={classes.paymentModeUsedCard}>
            <div className={classes.detailsDiv}>
                <Typography className={classes.cardHeader}>Paid Using</Typography>
                <div className={classes.section}>
                    <div className={classes.valueSec}>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            {getPaymentMode(data.paymentMode)}
                            <Typography className={classes.modeValueTxt}>{data && data.paymentMode && data.paymentMode =='NET_BANKING'?'Net Banking':data.paymentMode}</Typography>
                        </Box>
                        <Box component={'div'} display={'flex'} flexDirection={'column'} justifyContent={'end'}>
                            <Typography className={classes.amount}>{data && data.payoutAmount?numberFormat(data.payoutAmount):"---"}</Typography>
                        </Box>
                    </div>
                </div>
            </div>
      </Paper>}
      {data && data.brokerId?null:getTimelineCard()}
    </>
  );
}
export default PaymentDetailsCard;